import "./CancelProjectModal.css";

import { ActionButtons, Column, ErrorBox, InformationBox, Modal, Row } from "../../../../widget";
import { useCancelProjectModal } from "./useCancelProjectModal";

interface CancelProjectModalProps {
  isGroupProject: boolean;
  showCancelProjectModal: boolean;
  closeModal: () => void;
  refreshProject: () => void;
}

export const CancelProjectModal = ({
  isGroupProject,
  showCancelProjectModal,
  closeModal,
  refreshProject,
}: CancelProjectModalProps): JSX.Element => {
  const { errors, isHandleSubmitLoading, resetForm, handleSubmit } = useCancelProjectModal({
    closeModal,
    refreshProject,
  });

  return (
    <Modal
      show={showCancelProjectModal}
      title="Cancel Project"
      onClose={() => {
        resetForm();
        closeModal();
      }}
    >
      <form onSubmit={(e) => handleSubmit(e)} className="CancelProjectModalContent">
        {errors && errors.length > 0 && (
          <Row spacingV="ml" justify="center">
            <Column span={6}>
              <ErrorBox
                title="Please solve the below issues before saving"
                text={errors.map((error) => error.message)}
              />
            </Column>
          </Row>
        )}
        <Row spacingV="2xl" justify="center">
          <Column span={10}>
            <div className="CancelProjectModalTextWrapper">
              <p className="body1">
                If you cancel this project, it will no longer be visible in the public directory and you will not be
                able to start new activities against it. You will still be able to view it in the Kana system.
              </p>
              {isGroupProject && (
                <InformationBox variant="alert" title="This project is in a registry group">
                  <p className="body2">
                    Since this project is in a registry group, cancelling it will remove it from the group.
                  </p>
                </InformationBox>
              )}
              <p className="body1">Are you sure you want to cancel the project? This action cannot be undone.</p>
            </div>
          </Column>
        </Row>
        <Row justify="center">
          <Column span={6}>
            <ActionButtons
              onCancel={closeModal}
              fullWidth
              submitButtonLabel="Update"
              isLoading={isHandleSubmitLoading}
            />
          </Column>
        </Row>
      </form>
    </Modal>
  );
};
